var map = {
	"./404.png": "8f20",
	"./avatar.png": "690a",
	"./avatar2.png": "9c3a",
	"./baicoin.jpeg": "02f3",
	"./baicoin.png": "8d31",
	"./bg_aviso.png": "b76a",
	"./bg_bolao.png": "6285",
	"./bg_contato.png": "a33f",
	"./bg_fantasy.png": "2cf5",
	"./bg_noticia.png": "5485",
	"./bg_perfil.png": "8b2c",
	"./bg_player.png": "a818",
	"./bg_sucesso.png": "b70c",
	"./btn_fixed.png": "5d68",
	"./card_player_team.png": "90d8",
	"./cookie.png": "fa08",
	"./dv.png": "9045",
	"./fantasy1.png": "ce37",
	"./fantasy2.png": "ee4a",
	"./filter_adc.png": "8513",
	"./filter_jgn.png": "9f77",
	"./filter_jun.png": "cb8a",
	"./filter_mid.png": "9d89",
	"./filter_sup.png": "1b65",
	"./filter_top.png": "dc44",
	"./home1.png": "9b33",
	"./home1_md.png": "ba53",
	"./home2.png": "4b40",
	"./home3.png": "b899",
	"./home4.png": "0e42",
	"./home5.png": "b82b",
	"./home6.png": "776f",
	"./ico_adc.png": "c71c",
	"./ico_captain.png": "4227",
	"./ico_captain_active.png": "928b",
	"./ico_coa.png": "17d0",
	"./ico_coach.png": "f2d2",
	"./ico_coroa.png": "c978",
	"./ico_coroa_active.png": "521a",
	"./ico_coroa_active2.png": "ca82",
	"./ico_disc.png": "bbce",
	"./ico_espada.png": "21b5",
	"./ico_face.png": "b537",
	"./ico_face2.png": "d3a0",
	"./ico_jng.png": "91fc",
	"./ico_jun.png": "0bd3",
	"./ico_mid.png": "4fc1",
	"./ico_perdedor_active.png": "a58d",
	"./ico_select_player.png": "3a31",
	"./ico_select_player2.png": "6b01",
	"./ico_sucesso.png": "d17a",
	"./ico_sup.png": "3748",
	"./ico_top.png": "0556",
	"./ico_trophy.png": "65a7",
	"./ico_twitter.png": "917c",
	"./ico_twitter2.png": "a49a",
	"./ico_vencedor.png": "21cf",
	"./ico_vencedor2_active.png": "b16e",
	"./ico_vencedor_active.png": "f123",
	"./ico_whatsapp.png": "9847",
	"./login1.png": "22a8",
	"./logo-short.png": "911f",
	"./logo.png": "4ffd",
	"./map.png": "48dd",
	"./noticia1.png": "e359",
	"./noticia_interna.png": "c679",
	"./ondas.png": "574f",
	"./player.png": "f2db",
	"./text_lane_adc.png": "a94e",
	"./text_lane_coach.png": "9abc",
	"./text_lane_jng.png": "5a94",
	"./text_lane_jun.png": "2947",
	"./text_lane_mid.png": "f987",
	"./text_lane_sup.png": "b238",
	"./text_lane_top.png": "7d86",
	"./time.png": "e1fe",
	"./trophy.png": "7116",
	"./trophy2.png": "cbfe",
	"./wallet.png": "1e5a",
	"./wallet2.png": "319c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";